import { type ControllerApiConstructor } from './abstract'
import { AbstractSelfInitSdk } from './abstractSelfInit'
import { Catch } from './catchError'
import {
  AutocompleteControllerApi,
  type AutocompleteRequest,
  type AutocompleteResult,
  type HighlightedPlace,
  type Place,
  type SearchSuggestionsResult,
  type TransporterCode,
} from './generated'

export type SearchType = 'origin' | 'destination' | 'via'

export type AutocompleteSearchOptions = Omit<AutocompleteRequest, 'searchTerm'>

export class AutocompleteSdk extends AbstractSelfInitSdk<AutocompleteControllerApi> {
  protected getControllerApiConstructor(): ControllerApiConstructor<AutocompleteControllerApi> {
    return AutocompleteControllerApi
  }

  @Catch<AutocompleteResult>()
  async autocomplete(searchTerm: string, searchOptions: AutocompleteSearchOptions = {}): Promise<AutocompleteResult> {
    return (
      await this.api.findSearchPlaces(
        this.userSdk.getBffHeader(),
        {
          searchTerm,
          ...searchOptions,
        },
        this.userSdk.createAxiosOptions(),
      )
    ).data
  }

  @Catch<SearchSuggestionsResult>()
  async suggestions(searchType: SearchType): Promise<SearchSuggestionsResult> {
    return (
      await this.api.findSearchSuggestionsForType(
        searchType,
        this.userSdk.getBffHeader(),
        this.userSdk.createAxiosOptions(),
      )
    ).data
  }
}

export const toPlace: (place: { id: string; label: string; codes?: TransporterCode[] }) => Place = ({
  id,
  label,
  codes = [],
}) => ({
  label,
  id,
  codes,
  geolocation: false,
})

export const toHighlightedPlace = (
  place: Place,
  iconId = {
    iconGroup: 'Mobile',
    iconName: 'station',
  },
): HighlightedPlace => ({
  label: place.label,
  id: place.id,
  highlight: [],
  lines: [],
  linesIcons: [],
  codes: [],
  type: {
    label: '',
    iconId,
  },
})
